import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import profile from './components/profile/profile.component';

/**
 * @ngdoc overview
 * @name profile
 * @description
 * This module handles everything for the Profile section.
 */
const profileModule = angular.module('profile', [])
.config(routeProviderConfig)
.component('profile', profile);

export default profileModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/profile/index.js